module.exports = __webpack_public_path__ + "static/media/logo.f10bc946.svg";